module.exports = __webpack_public_path__ + "assets/calender-white.e0630c399f35fadec629fe7fca2222da.svg";